module.exports = __webpack_public_path__ + "img/sh.4a6b8018.jpg";